// export const server = "http://localhost:8000";
export const server = "https://classicmotorskeserver.vercel.app";
